import { useContext, useMemo } from "react";
import { PlaygroundContext } from "./PlaygroundProvider";
import { PlaygroundStateWithCurrentSession, Session } from "./types";
import { UnknownAction } from "@reduxjs/toolkit";

export const usePlaygroundDispatch = (): React.Dispatch<UnknownAction> => {
  const { dispatch } = useContext(PlaygroundContext);
  return dispatch;
};

export const usePlaygroundState = (): PlaygroundStateWithCurrentSession => {
  const { state } = useContext(PlaygroundContext);

  return useMemo(() => {
    const currentSession: Session | null =
      state.currentSessionId && state.sessions[state.currentSessionId]
        ? state.sessions[state.currentSessionId]
        : null;

    return {
      ...state,
      currentSession,
    };
  }, [state]);
};
